import { h, Component } from 'preact';
import { Router } from 'preact-router';

import Header from './header';
import Footer from './footer';

// Code-splitting is automated for routes
import Home from '../routes/home';
import Contact from '../routes/contact';
import About from '../routes/about';

export default class App extends Component {

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
	};

	render() {
		if (typeof window !== 'undefined') {
			document.addEventListener('DOMContentLoaded', () => {

				// Get all "navbar-burger" elements
				const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

				// Check if there are any navbar burgers
				if ($navbarBurgers.length > 0) {

					// Add a click event on each of them
					$navbarBurgers.forEach( el => {
						el.addEventListener('click', () => {

							// Get the target from the "data-target" attribute
							const target = el.dataset.target;
							const $target = document.getElementById(target);

							// Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
							el.classList.toggle('is-active');
							$target.classList.toggle('is-active');

						});
					});
				}
			});
		}
		return (
			<div id="app">
				<Header />
				<Router onChange={this.handleRoute}>
					<Home path="/" />
					<Contact path="/contact" />
					<About path="/about" />
				</Router>
				<Footer />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js